import React from 'react'
import { Typography, Box } from '@mui/material'
import { useOutletContext } from 'react-router-dom'

import WizardContainer from './shared/WizardContainer'
import LogoForm from '../settings/Logo'

const LogoInput = () => {
  const { navigateToNext, wizardState, updateWizardState } = useOutletContext()

  return (
    <Box>
      <WizardContainer>
        <Typography variant={'h5'} sx={{ mb: 2 }}>
          You have your golden ticket, LET’S GET STARTED!
        </Typography>
        <Typography sx={{ mb: 2 }}>
          Welcome to the wonderful world of StartUP CRM. This shiny new toy will
          be the keystone of your small business. We have designed this
          straightforward, step-by-step setup wizard to help walk you through
          the process of setting up your CRM quickly and efficiently. Keep your
          arms and legs in, it should only take about 45 minutes to get your
          company's personalized CRM going.
        </Typography>
        <Typography sx={{ mb: 2, alignSelf: 'center' }}>
          Let’s start with your company name and logo...
        </Typography>

        <LogoForm
          state={wizardState}
          updateState={updateWizardState}
          wizardFooterProps={{
            primaryButton: {
              label: 'Save and continue',
              onClick: navigateToNext,
            },
            hideBackButton: true,
          }}
        />
      </WizardContainer>
    </Box>
  )
}

export default LogoInput
